module.exports = __webpack_public_path__ + "consumption.f05fd6b373a60d00dc2c.png";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/consumption.png
// module id = ../../../../../src/assets/images/consumption.png
// module chunks = 2